async function getReferralCode() {
  try {
    const customerInfo = await window._erj_?.getAccountInfo?.();
    return customerInfo?.referralCode || null;
  } catch (e) {
    console.error("Failed to load referral code", e);
    return null;
  }
}

function composeReferralUrl(code) {
  const base = window.location.origin || "https://enroutejewelry.com";
  const url = new URL(base);
  code && url.searchParams.set("stamped_referral_code", String(code));
  url.searchParams.set("rewards-launcher", "view-referrals-claim");
  return url.toString();
}

function setInputValue(rootEl, url) {
  const input = rootEl.querySelector(".referral-link-input");
  if (input) input.value = url;
}

function animateCopy(rootEl) {
  if (rootEl?.classList?.contains("copied")) {
    rootEl.classList.remove("copied");
  }
  rootEl.classList.add("copying");
  setTimeout(() => {
    rootEl.classList.remove("copying");
    rootEl.classList.add("copied");
    setTimeout(() => {
      rootEl.classList.remove("copied");
    }, 600);
  }, 400);
}

function initCopy(rootEl) {
  const container = rootEl.querySelector('[data-component="referral-link"]');
  const input = rootEl.querySelector(".referral-link-input");
  const btn = rootEl.querySelector('[data-action="copy"]');
  if (!container || !input || !btn) return;

  btn.addEventListener("click", () => {
    const text = input.value || "";
    if (!text) return;
    navigator.clipboard
      ?.writeText(text)
      .then(() => {
        animateCopy(container);
      })
      .catch(() => {
        try {
          input.select();
          document.execCommand("copy");
          animateCopy(container);
        } catch (e) {
          console.warn("Copy failed", e);
        }
      });
  });
}

function shareTo(channel, url, linkText) {
  const encodedUrl = encodeURIComponent(url);

  let shareUrl = null;
  switch (channel) {
    case "facebook":
      shareUrl = `https://www.facebook.com/v2.12/dialog/send?app_id=941057476855139&fallback_redirect_uri=${encodedUrl}&link=${encodedUrl}&redirect_uri=${encodedUrl}`;
      break;
    case "whatsapp":
      shareUrl = `https://wa.me/?text=${linkText} ${encodedUrl}`;
      break;
    case "twitter":
      shareUrl = `https://twitter.com/intent/tweet?text=${linkText} ${encodedUrl}`;
      break;
    case "messenger":
      shareUrl = `https://www.facebook.com/v2.12/dialog/send?app_id=941057476855139&fallback_redirect_uri=${encodedUrl}&link=${encodedUrl}&redirect_uri=${encodedUrl}`;
      break;
    case "email":
      StampedFn.toggleRewardsModal();
      StampedFn.loadLauncherView(
        "view-referrals-email",
        document.querySelector(".stamped-rewards-content-container")
      );
      return;
    default:
      shareUrl = url;
  }
  window.open(shareUrl, "_blank");
}

function initShare(rootEl, url) {
  const container = rootEl.querySelector('[data-component="referral-share"]');
  if (!container) return;
  const linkText = container.dataset.linkText || "";
  container.querySelectorAll(".share-btn").forEach((btn) => {
    btn.addEventListener("click", () => {
      shareTo(btn.dataset.channel, url, linkText);
    });
  });
}

document.addEventListener("DOMContentLoaded", async () => {
  const rootEl = document.querySelector(".membership-referral");
  if (!rootEl) return;
  const code = await getReferralCode();
  const url = composeReferralUrl(code);
  setInputValue(rootEl, url);
  initCopy(rootEl);
  initShare(rootEl, url);
});
